import React from 'react'
import { Trans } from 'react-i18next';
import i18n from './i18n'
import { privacyPolicy} from '../cookiesPolicy'
import '../css/PoliPri.Module.css';
import { Link } from 'react-router-dom';
function PoliPriva() {
  return (
    <div className='container PoliPriva mt-5'>
        <div className='text'>
            
        </div>
      {privacyPolicy.map((item, index) => (
      <div className="poli-priva" key={index}>
        <Trans i18nKey={`cookiesPolicy_${index}`} components={{
            1: <h1 />,
            2: <strong />,
            3: <br />,
            4: <p />,
            5: <ul/>,
            6: <li/>,
            7: <a/>, 
            8: <Link/>, 
          }} >
          {item.text[i18n.language].replace(/&nbsp;/g, ' ')}
        </Trans>
      </div>
    ))}
      </div>
  )
}

export default PoliPriva